module.exports = __webpack_public_path__ + "static/media/charity-default-logo.e9d8c425.png";